const MINIMAL_PAGE_ITEM_COUNT = 5;

export const generatePageItems = (total: number, current: number, width: number, replaceNonEnding?: boolean) => {
  if (width < MINIMAL_PAGE_ITEM_COUNT) {
    throw new Error(`Must allow at least ${MINIMAL_PAGE_ITEM_COUNT} page items`);
  }
  if (width % 2 === 0) {
    throw new Error(`Must allow odd number of page items`);
  }
  if (total < width) {
    return [...new Array(total)].map((_, index) => ({
      value: index + 1,
      label: String(index + 1),
      active: current === index + 1,
    }));
  }
  const left = Math.max(0, Math.min(total - width, current - Math.floor(width / 2) - 1));
  const items: { value: number; label: string | number; active: boolean }[] = new Array(width);
  for (let i = 0; i < width; i += 1) {
    items[i] = { value: i + left, label: i + left, active: false };
  }

  if (replaceNonEnding) {
    // replace non-ending items with placeholders
    if (items[0].value > 0) {
      items[0] = { value: 0, label: 0, active: false };
      // prev-more
      items[1] = { value: left + 1, label: '...', active: false };
    }
    if (items[items.length - 1].value < total - 1) {
      items[items.length - 1] = { value: total - 1, label: total - 1, active: false };
      // next-more
      items[items.length - 2] = { value: left + width - 2, label: '...', active: false };
    }
  }

  return items.map(({ value, label }) => ({
    label: typeof label === 'number' ? String(label + 1) : label,
    value: value + 1,
    active: current === value + 1,
  }));
};
